<fw-dialog width="medium">
  <fw-dialog-header>
    <h3 class="vision-h3">
      Gear Access <span class="gear-name-title">• {{ gearLabel() }}</span>
    </h3>
  </fw-dialog-header>
  <fw-dialog-content class="fill-width">
    @if (isLoading()) {
      <fw-progress-bar mode="indeterminate"></fw-progress-bar>
    }
    <form [formGroup]="form">
      @if (isRestricted() && (isDeveloper() || isSiteAdmin())) {
        <fw-tabs [activeTabIndex]="0" [bordered]="true">
          <fw-tab tabindex="projects" [panel]="projectsPanel" [title]="'Projects'">
            <fw-badge
              test-id="selected-projects-count"
              variant="static"
              [fwTooltip]="selectedProjectLabels().join('\n')"
              [value]="selectedProjectLabels().length.toString()"
            >
            </fw-badge>
          </fw-tab>
          <fw-tab tabindex="users" [panel]="usersPanel" [title]="'Users'">
            <fw-badge
              test-id="selected-users-count"
              variant="static"
              [fwTooltip]="selectedUserLabels().join('\n')"
              [value]="selectedUserLabels().length.toString()"
            >
            </fw-badge>
          </fw-tab>
        </fw-tabs>

        <fw-tab-panel #projectsPanel>
          <div class="projects-panel-content">
            <div class="picker-row">
              <fw-multi-select
                #projectPicker
                placeholder="Add projects..."
                test-id="project-picker-select"
                width="100%"
                [closeOnSelect]="true"
                [filterFn]="projectPickerFilterFn"
                [formControl]="projectPickerControl"
                [maxSelectedShown]="5"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              >
                @for (project of allProjects(); track project._id) {
                  <fw-menu-item
                    [description]="groupLabels()[project.group]"
                    [title]="project.label"
                    [value]="project._id"
                  >
                  </fw-menu-item>
                }
              </fw-multi-select>
              <fw-button
                test-id="add-projects-button"
                [disabled]="!projectPickerControl.value?.length"
                (click)="addSelectedProjects()"
                >Add</fw-button
              >
            </div>

            @if (addedProjects().length > 0) {
              <fw-section-heading title="Projects with access"></fw-section-heading>
              <fw-table
                #addedProjectsTable
                test-id="added-projects-table"
                [class.scrollable]="isAddedProjectsTableScrollable()"
                [dataSource]="addedProjects()"
              >
                <ng-container matColumnDef="label">
                  <th *matHeaderCellDef fw-header-cell>Project</th>
                  <td *matCellDef="let project" fw-cell>{{ project.label }}</td>
                </ng-container>

                <ng-container matColumnDef="group">
                  <th *matHeaderCellDef fw-header-cell>Group</th>
                  <td *matCellDef="let project" fw-cell>{{ groupLabels()[project.group] }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th *matHeaderCellDef class="row-trash-column" fw-header-cell></th>
                  <td *matCellDef="let project" class="row-trash-column" fw-cell>
                    <fw-icon-button
                      icon="trash-delete"
                      test-id="remove-added-project-btn"
                      (click)="removeAddedProject(project._id)"
                    >
                    </fw-icon-button>
                  </td>
                </ng-container>

                <tr *matHeaderRowDef="addedProjectsColumns; sticky: true" fw-header-row></tr>
                <tr *matRowDef="let row; columns: addedProjectsColumns" fw-row></tr>
              </fw-table>
            }
          </div>
        </fw-tab-panel>

        <fw-tab-panel #usersPanel>
          <div class="users-panel-content">
            <div class="picker-row">
              <fw-multi-select
                #userPicker
                placeholder="Add users..."
                test-id="user-picker-select"
                width="100%"
                [closeOnSelect]="false"
                [filterFn]="userPickerFilterFn"
                [formControl]="userPickerControl"
                [maxSelectedShown]="5"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              >
                @for (user of allUsers(); track user._id) {
                  <fw-menu-item
                    [description]="user.email"
                    [title]="user.firstname + ' ' + user.lastname"
                    [value]="user._id"
                  >
                    <fw-avatar
                      size="medium"
                      variant="circular"
                      [colorSeed]="user | userInitial"
                      [content]="user | userAvatarContent"
                      [imageUrl]="user | userAvatarUrl"
                      [initial]="user | userInitial"
                    />
                  </fw-menu-item>
                }
              </fw-multi-select>
              <fw-button
                test-id="add-users-button"
                [disabled]="!userPickerControl.value?.length"
                (click)="addSelectedUsers()"
                >Add</fw-button
              >
            </div>

            @if (addedUsers().length > 0) {
              <fw-section-heading title="Users with access"></fw-section-heading>
              <fw-table
                #addedUsersTable
                test-id="added-users-table"
                [class.scrollable]="isAddedUsersTableScrollable()"
                [dataSource]="addedUsers()"
              >
                <ng-container matColumnDef="name">
                  <th *matHeaderCellDef fw-header-cell>Name</th>
                  <td *matCellDef="let user" fw-cell>
                    <fw-avatar
                      size="medium"
                      variant="circular"
                      [colorSeed]="user | userInitial"
                      [content]="user | userAvatarContent"
                      [imageUrl]="user | userAvatarUrl"
                      [initial]="user | userInitial"
                    ></fw-avatar>
                    {{ user.firstname }} {{ user.lastname }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="email">
                  <th *matHeaderCellDef fw-header-cell>Email</th>
                  <td *matCellDef="let user" fw-cell>{{ user.email }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th *matHeaderCellDef class="row-trash-column" fw-header-cell></th>
                  <td *matCellDef="let user" class="row-trash-column" fw-cell>
                    <fw-icon-button
                      icon="trash-delete"
                      test-id="remove-added-user-btn"
                      (click)="removeAddedUser(user._id)"
                    >
                    </fw-icon-button>
                  </td>
                </ng-container>

                <tr *matHeaderRowDef="addedUsersColumns; sticky: true" fw-header-row></tr>
                <tr *matRowDef="let row; columns: addedUsersColumns" fw-row></tr>
              </fw-table>
            }
          </div>
        </fw-tab-panel>
      }

      <div class="restrict-access">
        <fw-contained-input
          description="Turning on restricted access allows you to limit a gear to specific groups,
            projects, and users you define. Turning off restricted access will open the gear to everyone on your site"
          formControlName="isRestricted"
          test-id="gear-access-restrict-access-switch"
          title="Restricted Access"
          [status]="isRestricted() ? 'ON' : 'OFF'"
        >
          <fw-avatar icon="lock" size="medium" variant="rounded" />
        </fw-contained-input>
      </div>
    </form>
  </fw-dialog-content>
  <fw-dialog-actions class="fill-width">
    @if (hasChanged() && !isLoading()) {
      <fw-button
        color="primary"
        data-class="reset-button"
        test-id="reset-button"
        variant="outline"
        [disabled]="isSaving()"
        (click)="reset()"
        >Reset Changes
      </fw-button>
      <fw-button
        color="primary"
        test-id="cancel-button"
        variant="outline"
        [disabled]="isSaving()"
        (click)="ref.close()"
      >
        Cancel
      </fw-button>
      <fw-button color="primary" test-id="save-button" [variant]="isSaving() ? 'progress' : 'solid'" (click)="save()">
        {{ isSaving() ? 'Saving...' : 'Save' }}
      </fw-button>
    }
    @if (!hasChanged() || isLoading()) {
      <fw-button color="primary" test-id="close-button" (click)="ref.close()">Close</fw-button>
    }
  </fw-dialog-actions>
</fw-dialog>
